import {useAppSelector} from "@Hooks/selector/useAppSelector";
import removeSelectedPassengerFromPreviousGroup
    from "@CheckOrder/features/classPicker/features/additionalPassengerClassSelectModal/functions/removeSelectedPassengerFromPreviousGroup";
import AvailablePassengerClassType from "@CheckOrder/features/classPicker/types/AvailablePassengerClass.type";

export default function useCleanPassengerClassToPassengersMapping(passengerId: number, selectedPassengerClass: AvailablePassengerClassType, isReturn: boolean) {
    const {
        singleSelectedPassengerClasses,
        returnSelectedPassengerClasses,
    } = useAppSelector((state) => (state.checkOrder.ticket))

    const selectedPassengerClasses = isReturn ? returnSelectedPassengerClasses : singleSelectedPassengerClasses

    const cleanPassengerClassToPassengersMapping = (classToPassengersMap: number[][]) => {
        const cleanedPassengerClassToPassengersMap = classToPassengersMap.map((passengerIdsGroup) => (
            removeSelectedPassengerFromPreviousGroup([...passengerIdsGroup], passengerId)
        ))

        return cleanedPassengerClassToPassengersMap.filter((passengerIdsGroup) => (passengerIdsGroup.length))
    }

    return (
        cleanPassengerClassToPassengersMapping(selectedPassengerClasses.classToPassengersMap[selectedPassengerClass.id])
    )
}